import React from "react";
import history from "./../../history";

import { Mutation } from "@apollo/client/react/components";
import { UPDATE_USER, DELETE_USER } from "./UserQueries";

import { Formik, Form, Field } from "formik";
import { UserUpdateValidationSchema } from "./UserValidationSchema";

import Heading from "components/Elements/Heading.js";

const UpdateUser = (data) => {
  const user = data.data[0];
  const selected_roles = user.roles.map((role) => role.id);
  const available_roles = data.roles;

  return (
    <div className="row">
      <div className="col-6">
        <Mutation mutation={UPDATE_USER}>
          {(userUpdate, { loading }) => (
            <Formik
              validateOnChange={false}
              validateOnBlur={false}
              validationSchema={UserUpdateValidationSchema}
              onSubmit={async (
                values,
                { setSubmitting, setStatus, resetForm }
              ) => {
                setStatus(undefined);
                let formData = {
                  ...values,
                  userID: user.id,
                  tenantID: parseInt(localStorage.defaultTenantID),
                };
                try {
                  await userUpdate({
                    variables: formData,
                  });

                  resetForm();
                  setStatus({
                    confirmation: `User ${values.firstName} ${values.lastName} has been updated`,
                  });

                  setSubmitting(false);
                } catch (err) {
                  // TODO
                  setStatus({
                    firstName: "API - error",
                    lastName: "API - error",
                    email: "API - error",
                  });
                  setSubmitting(false);
                }
              }}
              initialValues={{
                firstName: user.firstName,
                lastName: user.lastName,
                roleIDs: selected_roles,
              }}
            >
              {({ errors, status, touched, isSubmitting, setFieldValue }) => (
                <Form>
                  {status && status.confirmation && (
                    <div className="alert alert-success" role="alert">
                      {status.confirmation}
                    </div>
                  )}
                  <div className="form-group">
                    <label htmlFor="firstName">First Name</label>
                    <Field
                      id="firstName"
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      className="form-control"
                    />

                    {status && status.firstName ? (
                      <div className="invalid-feedback d-block">
                        {status.firstName}
                      </div>
                    ) : (
                      errors.firstName &&
                      touched.firstName && (
                        <div className="invalid-feedback d-block">
                          {errors.firstName}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name</label>
                    <Field
                      id="lastName"
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      className="form-control"
                    />

                    {status && status.lastName ? (
                      <div className="invalid-feedback d-block">
                        {status.lastName}
                      </div>
                    ) : (
                      errors.lastName &&
                      touched.lastName && (
                        <div className="invalid-feedback d-block">
                          {errors.lastName}
                        </div>
                      )
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <Field
                      id="email"
                      type="email"
                      name="email"
                      value={user.email}
                      className="form-control"
                      disabled
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="roleIDs">Permissions</label>
                    <Field
                      id="roleIDs"
                      name="roleIDs"
                      component="select"
                      multiple={true}
                      className="form-control"
                      onChange={(event) =>
                        setFieldValue(
                          "roleIDs",
                          [...event.target.options]
                            .filter((o) => o.selected)
                            .map((o) => parseInt(o.value))
                        )
                      }
                    >
                      {available_roles.map((role) => (
                        <option key={role.id} value={role.id}>
                          {role.name}
                        </option>
                      ))}
                    </Field>

                    {status && status.roleIDs ? (
                      <div className="invalid-feedback d-block">
                        {status.roleIDs}
                      </div>
                    ) : (
                      errors.roleIDs &&
                      touched.roleIDs && (
                        <div className="invalid-feedback d-block">
                          {errors.roleIDs}
                        </div>
                      )
                    )}
                  </div>

                  <div className="form-group">
                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      {loading ? "Updating User..." : "Update User"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </Mutation>
        <hr className="mt-5 mb-5" />
        <Heading size={3} className={"mb-4 mt-4"}>
          Delete User
        </Heading>
        <p>
          Deleting a user will remove all of its data and preferences
          permanently.
        </p>

        <Mutation mutation={DELETE_USER} variables={{ userID: user.id }}>
          {(deleteUser, { loading, error, data }) => {
            const handleDeleteUser = () => {
              let result = window.confirm(
                "Are you sure you want to delete this user?"
              );

              if (result) {
                deleteUser({
                  variables: {
                    tenantID: parseInt(localStorage.defaultTenantID),
                    userID: user.id,
                  },
                });

                if (error) {
                  alert("There was a problem deleting this user");
                }

                if (!loading && !error) {
                  history.push(
                    `/settings/users?deleted_first=${user.firstName}&deleted_last=${user.lastName}`
                  );
                }
              }
            };

            return (
              <button
                className="btn btn-danger btm-sm"
                onClick={() => handleDeleteUser()}
              >
                {loading ? "Deleting User..." : "Delete User"}
              </button>
            );
          }}
        </Mutation>
      </div>
    </div>
  );
};

export default UpdateUser;
